import { ChannelConfigListPage } from "@/features/channel-config/pages/ChannelConfigListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/channel-config/")({
	component: ChannelConfigListPage,
});
